import { deClientPortalComparablesCategory } from './ValuationMarketData/Comparables/ComparablesCategory'
import { deClientPortalValuationComparables } from './ValuationMarketData/Comparables/ValuationComparables'
import { deClientPortalAssetPreview } from './ValuationMarketData/Comparables/Preview/AssetPreview'
import { deClientPortalRatingChip } from './ValuationMarketData/Comparables/Preview/RatingChip'

export const deClientPortalValuationMarketData = {
    valuationComparables: deClientPortalValuationComparables,
    comparablesCategory: deClientPortalComparablesCategory,
    assetPreview: deClientPortalAssetPreview,
    ratingChip: deClientPortalRatingChip,
}
